<template>
  <v-app>
    <Header v-show="!inAssessmentPage"/>
    <div class="content" :style="{ 'margin-top': inAssessmentPage ? '' : '64px' }">
      <router-view :key="$route.name + (componentKey || '')"></router-view>
    </div>
    <Footer v-show="!inAssessmentPage"/>
  </v-app>
</template>

<script>
import Header from '@/components/header/Header'
import Footer from '@/components/footer/footer'

import { mapState } from 'vuex'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState({
      componentKey: state => state.book.componentKey
    }),
    inAssessmentPage () {
      let routeName = this.$route.name

      return routeName.includes('assessment') || routeName.includes('study-card') || routeName.includes('notes')
    }
  }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Mulish&display=swap");
@import "@/assets/scss/variables.scss";

* {
  font-family: "Mulish", sans-serif;
}

.content {
  background-color: $layout-background-color;
  height: 100%;
}

@media (max-width: 1100px) {
  .content {
    margin-left: 0px;
  }
}
</style>
